import { createSlice } from "@reduxjs/toolkit";
import { IState } from "../..";
import { AppThunk } from "../../../app/store";
import { initialTransactionMessagesState } from "./TransactionMessagesState";
import TransactionMonitorService from "../../../app/data/transaction-monitor/transactionMonitorService";
import { TransactionMessagesRequest } from "../../../app/data/transaction-monitor/models";

const DEFAULT_PAGE_SIZE = 50;

const transactionMonitorService = TransactionMonitorService.getInstance();

export const transactionMessagesSlice = createSlice({
  name: "transactionMessagesSlice",
  initialState: initialTransactionMessagesState,
  reducers: {
    resetTransactionMessages: () => initialTransactionMessagesState,
    requestStarted: (state, { payload }) => {
      if (payload.requestCreator === "GET_TRANSACTION_MESSAGES_PORTION") {
        state.fetchPortionStarted = true;
      } else {
        state.requestStarted = true;
      }
      state.requestSucceed = false;
      state.requestFailed = false;
      state.requestCreator = payload;
      state.requestError = "";
    },
    requestSucceed: (state) => {
      state.requestStarted = false;
      state.fetchPortionStarted = false;
      state.requestSucceed = true;
      state.requestFailed = false;
    },
    requestFailed: (state, { payload }) => {
      state.requestStarted = false;
      state.fetchPortionStarted = false;
      state.requestSucceed = false;
      state.requestFailed = true;
      state.requestFailStatus = payload.status;
      state.requestError = payload.error;
    },
    setTransactionMessages: (state, { payload }) => {
      state.messages = payload.data;
      state.nextCursor = (payload && payload.nextCursor) ? payload.nextCursor : null;
      state.hasNextPage = (payload && payload.hasNextPage) ? payload.hasNextPage : false;
    },
    addTransactionMessages: (state, { payload }) => {
      state.messages = [...state.messages, ...payload.data];
      state.nextCursor = (payload && payload.nextCursor) ? payload.nextCursor : null;
      state.hasNextPage = (payload && payload.hasNextPage) ? payload.hasNextPage : false;
    }
  },
});

export const {
  resetTransactionMessages,
  requestStarted,
  requestSucceed,
  requestFailed,
  setTransactionMessages,
  addTransactionMessages
} = transactionMessagesSlice.actions;

export const transactionMessagesSelector = (state: IState) => state.transactionMessages;

export const getTransactionMessages = (
  requestData: TransactionMessagesRequest,
  onError?: (error: string) => void
): AppThunk => async (dispatch) => {
  dispatch(requestStarted({
    requestCreator: requestData.cursor ? "GET_TRANSACTION_MESSAGES_PORTION" : "GET_TRANSACTION_MESSAGES"
  }
  ));
  const response = await transactionMonitorService.getTransactionMessages({...requestData, limit: DEFAULT_PAGE_SIZE});
  if (response.ok() && response.data) {
    console.log(response)
    dispatch(requestData.cursor ? addTransactionMessages(response.data) : setTransactionMessages(response.data));
    dispatch(requestSucceed());
  } else {
    let error = "Internal Server Error, re-try the action or contact support";
    if (response && response.data && response.data.message) error = response.data.message;
    dispatch(requestFailed({
      status: response.status,
      error
    }));
    onError && onError(error)
  }
};

const transactionMessagesReducer = transactionMessagesSlice.reducer;
export default transactionMessagesReducer;